import { render, staticRenderFns } from "./setting_group.vue?vue&type=template&id=6ffad364&scoped=true"
import script from "./setting_group.vue?vue&type=script&lang=ts"
export * from "./setting_group.vue?vue&type=script&lang=ts"
import style0 from "./setting_group.vue?vue&type=style&index=0&id=6ffad364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffad364",
  null
  
)

export default component.exports